<template>
    <div id="div_spJobList"
        :style="{
            background: GET_colorTheme.panels,
            display: active ? 'initial' : 'none'
        }"
    >
        <div id="div_jobList_header">
            <table width="100%">
                <tr>
                    <td class="jobList_body_text">Total</td>
                    <td>{{ (GET_jobs ? GET_jobs.length : 0 ) }}</td>
                </tr>
                <tr :style="{ background : gConsts.job.colors.EMPTY }">
                    <td class="jobList_body_text">Vazias</td>
                    <td>{{ GET_emptyJobs.length }}</td>
                </tr>
                <tr>
                    <td colspan="2" class="jobList_body_text">Incompletas</td>
                </tr>
                <tr :style="{ background : gConsts.job.colors.PARTIAL }">
                    <td class="jobList_body_text_subItem">Parciais</td>
                    <td>{{ GET_partialJobs.length }}</td>
                </tr>
                <tr :style="{ background : gConsts.job.colors.DOUBT }">
                    <td class="jobList_body_text_subItem">Dúvidas</td>
                    <td>{{ GET_doubtJobs.length }}</td>
                </tr>
                <tr :style="{ background : gConsts.job.colors.DIVERGENT }">
                    <td class="jobList_body_text_subItem">Divergências</td>
                    <td>{{ GET_divergentJobs.length }}</td>
                </tr>
                <tr :style="{ background : gConsts.job.colors.DISCARDED }">
                    <td class="jobList_body_text_subItem">Descartadas</td>
                    <td>{{ GET_discardedJobs.length }}</td>
                </tr>
                <tr :style="{ background : gConsts.job.colors.CONFIRMED }">
                    <td class="jobList_body_text">Completas</td>
                    <td>{{ GET_completedJobs.length }}</td>
                </tr>
            </table>
        </div>

        <div id="div_jobList_data">
            <ul class="ulMain">
                <li v-for="(job, index) in GET_jobs" 
                    :key="`${job.id} - ${index}`"
                    @click="ACT_jobUpdate({ index : index })"
                    @contextmenu.prevent=""
                    v-bind="{                                
                        id    : `li_job[ ${index} ]`,
                        class : {liMain : true, selLi : ($store.state.runtime.active.jobIndex == index)},
                        style : { background : utils.jobColor(job.state) },
                        title : job.id
                    }"
                    >{{ `[ ${index} ] ${job.id}` }}
                </li>
            </ul>
        </div>

        <div 
            id="div_jobList_controls"
            style="padding:0px"
        >
            <buttonCMP 
                id="jobControls_doubt" 
                hint="Marca a imagem corrente como [Dúvida] e pula para a próxima da lista"
                :img="require('@/assets/imgs/btDoubt.gif')"
                :style="jobControlsStyle"
                @click="jobControls(gConsts.job.controls.DOUBT)"
            ></buttonCMP>

            <buttonCMP 
                id="jobControls_discard" 
                hint="Descarta a imagem corrente e pula para a próxima da lista"
                :img="require('@/assets/imgs/btDiscard.gif')"
                :style="jobControlsStyle"
                @click="jobControls(gConsts.job.controls.DISCARD)"
            ></buttonCMP>

            <buttonCMP 
                id="jobControls_back" 
                hint="Volta para a imagem anterior"
                :img="require('@/assets/imgs/btBack.svg')"
                :style="jobControlsStyle"
                @click="jobControls(gConsts.job.controls.BACK)"
            ></buttonCMP>

            <buttonCMP 
                id="jobControls_skip" 
                hint="Marca a imagem corrente como [Parcial] (se houver anotações) e pula para a próxima da lista"
                :img="require('@/assets/imgs/btSkip.svg')"
                :style="jobControlsStyle"
                @click="jobControls(gConsts.job.controls.SKIP)"
            ></buttonCMP>

            <buttonCMP
                :color="gConsts.job.colors.CONFIRMED"
                hint="Marca a imagem corrente como [Completa] e pula para a próxima da lista"
                id="jobControls_confirm" 
                :img="require('@/assets/imgs/confirmBW.gif')"
                :style="jobControlsStyle"
                @click="jobControls(gConsts.job.controls.CONFIRM)"
            ></buttonCMP>
        </div>

    </div>
</template>

// =========================================================================================
// =========================================================================================

<script>
import buttonCMP from '@/components/ui/button.vue';
import { gConsts } from '@/globals/gConsts';
import { utils   } from '@/globals/utils';
import { mapGetters, mapState, mapActions } from 'vuex';

// =========================================================================================

export default {
    name : 'imgListCMP',

    components: {
        buttonCMP
    },

    props: {
        active : Boolean,
    }, 

    // -----------------------------------------------------------------

    data () {
        return {
            gConsts : gConsts,
            utils : utils,
        }
    },

    // -----------------------------------------------------------------

    computed: {  
        ...mapState([
        ]),

        // -----------------------------------------------------------------

        ...mapGetters([
            'GET_jobs',
            'GET_emptyJobs',
            'GET_partialJobs',
            'GET_doubtJobs',
            'GET_divergentJobs',
            'GET_discardedJobs',
            'GET_completedJobs',
            'GET_colorTheme',            
        ]),

        // -----------------------------------------------------------------

        jobControlsStyle() {
            return { 
                width  : '20px', 
                height : '20px',
                padding : '3px'
            }
        },
    },

    // -----------------------------------------------------------------

    methods: {
        ...mapActions([
                'ACT_jobUpdate',
        ]),

        // -----------------------------------------------------------------

        jobControls: function(control) {
            this.ACT_jobUpdate({ control : control });
        },
    }
}
</script>

// =========================================================================================
// =========================================================================================

<style scoped>

#div_jobList_container {
    background: #f3f3f3;
    display: grid;
    overflow: hidden;
    grid-template-columns : auto;
    grid-template-rows    : 185px auto 40px;
    grid-template-areas :
        "jobList_header"
        "jobList_data"
        "jobList_controls";
    grid-row-gap: 5px;
    z-index: 1;
    box-shadow: 1px 0px 5px -2px #000000;
}

#div_jobList_header {
    grid-area: jobList_header;
    box-shadow: 0px 2px 5px -2px #000000;
    z-index: 40;
}

.jobList_body_text {
    text-align : left;
}

.jobList_body_text_subItem {
    text-align   : left;
    padding-left : 20px;
}

#div_jobList_data {
    grid-area: jobList_data;
    box-shadow: 0px 1px 4px 0px rgba(150, 150, 150, 0.5);
    z-index: 40;
    position: relative;
    overflow: auto;
}

#div_jobList_controls {
    grid-area: jobList_controls;
    box-shadow: 0px -2px 5px -2px #000000;
}

</style>